<template>
    <div class="admin">
        <div class="d-flex flex-row" style="background: white;">
            <div id="sidebar" :class="{ hide: !showSidebar }">
                <SideBar v-if="showSidebar" />
            </div>

            <div class="container-fluid" style="background: #f4f4f5; padding: 0">
                <TopBar msg="이거슨 제일 위에에요" />

                <div style="padding: 2rem; background: #f4f4f5;">
                    <router-view></router-view>
                    <Footer msg="이그시 푸터" />
                </div>
            </div>
        </div>
    </div> <!--admin end--->
</template>

<script>
// @ is an alias to /src
import TopBar from '@/components/TopBar.vue'
import SideBar from '@/components/SideBar.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'admin',
    components: {
        TopBar,
        SideBar,
        Footer
    },
    data() {
        return {
            showSidebar: true,
        };
    },
    methods: {
        toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
    },
}
</script>
